//(function () {
    //'use strict';

    angular
        .module('app')
        .controller('KPIDashboard', KPIDashboard);

    function KPIDashboard($scope, $rootScope, $http, $cookies, $location, $timeout, $interval, $state, $q, $modal,
                          UserPreferenceService, BrandService, SeasonService, SharedData, toaster, DashboardService, PreferencesState, UserService) {
        //stringified version of the dashboard object, for storing in the database
        $rootScope.dashboardModelString = "";
        $scope.seasons = [];
        $scope.brands = [];

        $scope.PreferencesState = PreferencesState;


        //fill the Brands DDL
        BrandService.getBrandsByUser().then(function (response) {
            if (response) {
                $scope.brands = response;
            }
        });

        //fill the Seasons DDL after a user selects a brand
        $scope.getSeason = function (brandId) {
            $scope.noBrandAndSeasonSelected = false;
            PreferencesState.seasonId = '';
            if (brandId) {
                SeasonService.getSeasonsByBrand(brandId).then(function (response) {
                    if (response) {
                        $scope.seasons = response;
                        $scope.noBrandSelected = false;
                        $scope.SeasonId = 0;
                    }
                });

            }
            else {
                $scope.seasons.length = 0;
                $scope.noBrandSelected = true;
            }
        };

        var getUserDefaults = function () {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    $scope.brands = response.brands;
                    $scope.seasons = response.seasons;

                    PreferencesState.setBrand(response.brandId);
                    PreferencesState.seasonId = response.seasonId;
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error getting default brand and season data',
                        timeout: 5000
                    });
                }
            });
        };

        UserService.shouldShowStartupHelp().then(function (data) {
            if (!data) {
                getUserDefaults();
            }
        });

        //update the shared data object if the user changes brand or season
        $scope.applyUserBrandSeason = function (brandId, seasonId) {
            if (brandId) {
                SharedData.setBrandId(brandId);
            }

            if (seasonId) {
                SharedData.setSeasonId(seasonId);
            }
            SharedData.triggerRefresh();
        }

        //object to be sent to API for updating the database
        var updateModel = { userPreferenceId: 0, model: "" };

        //display name
        var name = "";

        //object that holds the dashboard model
        var dmodel = {};

        $rootScope.dashboardModelString = JSON.stringify($rootScope.dashboardModel);
        $scope.name = name;
        $scope.dmodel = dmodel;
        $scope.collapsible = false;
        $scope.maximizable = false;
        $scope.categories = false;
        $scope.availableWidgets = {};

        $scope.widgetFilter = function (widget, type, model) {
            return $scope.availableWidgets.hasOwnProperty(type);
        };

        $scope.fillModel = function () {
            $scope.dmodel = {};
            //get user's dashboard preferences (based on userId)
            UserPreferenceService.getDashboardPreferences().then(function (response) {

                var item1 = response[0];

                    //turn the string into an object, and assign it to the dashboard model
                dmodel = JSON.parse(item1.PreferenceValue);

                //set the userPreferenceId and dashboard model (as string)
                //we'll need this to update the database later
                updateModel.userPreferenceId = item1.UserPreferenceId;
                updateModel.model = item1.PreferenceValue;

                $scope.dmodel = dmodel;

                var widgetCount = 0;

                angular.forEach(dmodel.rows[0].columns, function (k, v) {
                    if (k.widgets && k.widgets.length > 0) {
                        widgetCount++;
                    }
                });

                if (widgetCount === 0) {
                    $scope.dmodel.widgets = false;
                } else {
                    $scope.dmodel.widgets = true;
                }
            },
            function (error, status) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was an error retrieving the dashboard model. Please contact the system administrator',
                    timeout: 5000
                });
            });

            DashboardService.getAvailableWidgets().then(function (data) {
                if (data) {
                    for (var i in data) {
                        if (data.hasOwnProperty(i)) {
                            var widget = data[i];
                            $scope.availableWidgets[widget] = widget;
                        }
                    }
                }
            });
        }

        $scope.fillModel();
        //   }

        //watch the dashboard model string
        //when it gets updated by dashboard.js, we want
        //to know so we can save the changes to the database
        $scope.$watch('dashboardModelString', function (newValue, oldValue, scope) {

            if (newValue) {
                //make sure we have a model to update

                //update the dashboard model string with the new string
                updateModel.model = newValue;

                //check to make sure we have a userPreferenceId
                if (updateModel.userPreferenceId > -1) {
                    //send the updated data to the API for storing in the DB
                    UserPreferenceService.updateDashboardPreferences(updateModel).then(function (response) {
                        if (response) {

                            //response will either be 1 for success, or 0 for error
                            if (response > 0) {

                                if (updateModel.userPreferenceId == 0) {
                                    //this was a new insert, update the userPreferenceId with the IDENTITY
                                    updateModel.userPreferenceId = response;
                                }
                                toaster.pop({
                                    type: 'success',
                                    title: 'Save complete!',
                                    body: 'Your dashboard preferences have been saved.',
                                    timeout: 5000
                                });
                            }
                            else {
                                toaster.pop({
                                    type: 'error',
                                    title: 'Error!',
                                    body: 'There was an error saving your dashboard preferences.',
                                    timeout: 5000
                                });
                            }

                        }
                        else {
                            toaster.pop({
                                type: 'error',
                                title: 'Error!',
                                body: 'There was an error saving your dashboard preferences.',
                                timeout: 5000
                            });
                        }
                        $scope.fillModel();
                    },
                    function (error, status) {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'There was an error saving your dashboard preferences.',
                            timeout: 5000
                        });
                    });
                }
            }
        }, true);
    }
//})();
